import createStore from "astrid-helpers/src/createStore";

export const [getSelectedPause, setSelectedPause, useSelectedPause, onSelectedPause] = createStore();
